import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addPaymentApi,
  getAllPaymentsApi,
  getPaymentsByCustomerApi,
  getPaymentsGraphApi,
  getPendingPaymentsApi,
  getTotlaPaymentsApi,
} from '../api/payments.service';
import {errorHandler} from '../utils/errorHandler';

function* getPaymentsByCustomerSaga(fn) {
  try {
    const response = yield call(getPaymentsByCustomerApi, fn.customerId);
    yield put({type: AC.GET_CUSTOMER_PAYMENTS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMER_PAYMENTS_FAILED);
  }
}

function* addPaymentSaga(fn) {
  try {
    const response = yield call(addPaymentApi, fn.payload);
    yield put({
      type: AC.ADD_PAYMENT_SUCCEED,
      payload: response.data,
      customerId: fn.payload.customerId,
    });
    yield put(successToast('Payment successful!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_PAYMENT_FAILED);
  }
}

function* getAllPaymentsSaga(fn) {
  try {
    const response = yield call(getAllPaymentsApi, fn.filters);
    yield put({
      type: AC.GET_ALL_PAYMENTS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_ALL_PAYMENTS_FAILED);
  }
}

function* getTotalPaymentsSaga(fn) {
  try {
    const response = yield call(getTotlaPaymentsApi, fn.filters);
    yield put({
      type: AC.GET_TOTAL_PAYMENTS_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_TOTAL_PAYMENTS_FAILED);
  }
}

function* getPaymentsGraphSaga() {
  try {
    const response = yield call(getPaymentsGraphApi);
    yield put({type: AC.GET_PAYMENTS_GRAPH_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_PAYMENTS_GRAPH_FAILED);
  }
}

function* getPendingPaymentsSaga(fn) {
  try {
    const response = yield call(getPendingPaymentsApi, fn.filters);
    yield put({
      type: AC.GET_PENDING_PAYMENTS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_PENDING_PAYMENTS_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [AC.GET_CUSTOMER_PAYMENTS_REQUEST, AC.ADD_PAYMENT_SUCCEED],
    getPaymentsByCustomerSaga,
  );
  yield takeLatest(AC.ADD_PAYMENT_REQUEST, addPaymentSaga);
  yield takeLatest(AC.GET_ALL_PAYMENTS_REQUEST, getAllPaymentsSaga);
  yield takeLatest(AC.GET_TOTAL_PAYMENTS_REQUEST, getTotalPaymentsSaga);
  yield takeLatest(AC.GET_PAYMENTS_GRAPH_REQUEST, getPaymentsGraphSaga);
  yield takeLatest(AC.GET_PENDING_PAYMENTS_REQUEST, getPendingPaymentsSaga);
}

export default function* paymentsSaga() {
  yield all([actionWatcher()]);
}
